import { Badge, UncontrolledTooltip } from 'reactstrap';
import styled from 'styled-components';

const AntiflickerTooltip = styled(UncontrolledTooltip)`
  pointer-events: none;
`;

const BetaBadge = () => {
  return (
    <>
      <Badge className="ml-2 font-weight-normal" size="sm" id="BetaBadge">
        Beta
      </Badge>
      <AntiflickerTooltip
        className="pe-none"
        placement="bottom"
        target="BetaBadge"
        fade={false}
      >
        You may notice some bugs while using this feature - we&apos;re working
        on it!
      </AntiflickerTooltip>
    </>
  );
};

export default BetaBadge;
